import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import './ShopConsultResults.scss';

import { setVisibleConsult } from '../../Actions/StoreActions';

import Loader from '../Loader/Loader';
import ConsultPreview from '../Consults/ConsultPreview';
import { getUsername } from '../../Helpers/user_helpers';

const ShopConsultResults = props => {
  const { isFetchingResults, consultResults } = props;
  const oldShopPageUrl = `/${getUsername(props.user)}/consults`;
  const showLoader = isFetchingResults && !consultResults.length;
  return (
    <div className='shop-consult-results-outer-container'>
      <div className='shop-consult-results-inner-container'>
        {showLoader ? (
          <Loader />
        ) : props.hadErrorResults ? (
          <div className='shop-consult-results-error-container'>There was an error, please reload to try again.</div>
        ) : consultResults.length > 0 ? (
          <div>
            {props.isYourShop && (
              <div className='warning-message'>
                Consults are not yet editable or fulfillable in the new shop design, please use <Link to={oldShopPageUrl}>the old shop page</Link> to
                add or update your consultations. If you would like to remove this section from your shop, please do so in your{' '}
                <Link to='/settings?tab=Shop+Settings'>account settings</Link>.
              </div>
            )}
            {consultResults.map((consult, idx) => {
              return <ConsultPreview key={consult.id} idx={idx} canEdit={false} setVisibleConsult={props.setVisibleConsult} consult={consult} />;
            })}
          </div>
        ) : props.isYourShop ? (
          <div className='warning-message'>
            Consultations will soon undergo a makeover, for now to create new consultations, please go to the{' '}
            <Link to={oldShopPageUrl}>old shop page</Link> to create, edit and fulfill your consultations.
          </div>
        ) : (
          <div className='shop-consult-results-empty-container'>No consultations found.</div>
        )}
      </div>
    </div>
  );
};

ShopConsultResults.propTypes = {
  // From Inside
  user: PropTypes.object.isRequired,

  // From Outside
  isFetchingResults: PropTypes.bool.isRequired,
  consultResults: PropTypes.array.isRequired,
  setConsultResults: PropTypes.func.isRequired,
  isYourShop: PropTypes.bool.isRequired
};

const mapStateToProps = state => {
  const { user } = state;
  return { user };
};

export default connect(mapStateToProps, {
  setVisibleConsult
})(ShopConsultResults);
